<template>
  <div class="experience-filter-container map">
    <div class="row expanded">
      <div class="columns large-12 large-centered filter-bar-container">
        <div class="hide-for-small-only filter-bar--large alt map">
          <div class="filter-bar--pane" style="padding-bottom: 20px;">
            <div class="row medium-collapse filter-bar--panerow">
              <div class="filter-bar--filters">
                <div class="columns medium-3">
                  <label for="subject">Category</label>
                  <p>
                    <select class="filter-bar--input" v-model="type">
                      <option value="all">All</option>
                      <option v-for="typ in types" :value="typ.slug">
                        {{ typ.name }}
                      </option>
                    </select>
                  </p>
                </div>
                <div class="columns medium-3">
                  <label for="subject">Type</label>
                  <p>
                    <select class="filter-bar--input" v-model="category">
                      <option value="all">All</option>
                      <option v-for="cat in categories" :value="cat.slug">
                        {{ cat.name }}
                      </option>
                    </select>
                  </p>
                </div>
                <div class="columns medium-3">
                  <label for="subject">Search</label>
                  <p>
                    <input @keyup="filterAll" v-model="keywords" class="filter-bar--input" type="text" value="" name="search" placeholder="Keyword">
                    <!-- <input v-model="keywords" class="filter-bar--input" type="text" value="" name="search" placeholder="Keyword"> -->
                  </p>
                </div>
                <div class="columns medium-3">
                  <label for="subject">Near</label>
                  <p>
                    <select class="filter-bar--input" v-model="location">
                      <option value="all">Location</option>
                      <option v-for="loc in locations" :value="loc.slug">
                        {{ loc.name }}
                      </option>
                    </select>
                  </p>
                </div>
              </div>
              <div class=" filter-bar--button-combo">
                <div class="custom-select filter maps">
                </div>
                <button @click="resetAllFilters" class="button" type="button">Clear</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile -->
    <div class="filter-bar--mobile-container show-for-small-only">
      <div class="o-listing-filter">
        <div class="o-listing-filter__mobile-container">
          <div class="row">
            <div class="columns small-10 small-centered">
              <ul data-accordion data-allow-all-closed="true" class="accordion filter-bar show-for-small-only" role="tablist">
                <li data-accordion-item="">
                  <a href="#"  role="tab">
                    <div class="o-listing-filter__toggle-container">
                      <button type="button" class="o-listing-filter__toggle">
                        Filter by<i class="icon ion-android-arrow-dropdown"></i>
                      </button>
                    </div>
                  </a>
                  <div data-tab-content class="accordion-content o-listing-filter__pane" role="tabpanel">
                    <div class="o-listing-filter__filter-space"><label for="subject">Type</label>
                      <p><select class="filter-bar--input" v-model="category">
                          <option value="all">All</option>
                          <option v-for="cat in categories" :value="cat.slug">
                            {{ cat.name }}
                          </option>
                        </select>
                      </p>
                    </div>
                    <div class="o-listing-filter__filter-space"><label for="subject">Search</label>
                      <p><input @keyup="filterAll" v-model="keywords" class="filter-bar--input" type="text" value="" name="search" placeholder="Keyword"></p>
                    </div>
                    <div class="o-listing-filter__filter-space"><label for="subject">Near</label>
                      <p>
                        <select class="filter-bar--input" v-model="location">
                          <option value="all">All Locations</option>
                          <option v-for="loc in locations" :value="loc.slug">
                            {{ loc.name }}
                          </option>
                        </select>
                      </p>
                    </div>
                    <div class="o-listing-filter__filter-button small-12 u-center">
                      <button @click="resetAllFilters" class="button" type="button">Clear</button>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <gmap :members='filteredList' v-if="isReady"></gmap>



  </div>
</template>


<script>

  import Gmap from './vue-partials/gmap.vue';

  export default {

    name: 'MemberList',

    props: {
      members: {
        type: Array,
      }
    },

    data () {
      return {

        /**
        * Bound to our search input
        * @type {String}
        */
        keywords: '',

        // map: null,
        // mapLoaded: false,

        /**
        * Will be generated from the passed in Experiences
        * @type {Array}
        */
        locations: [],

        /**
        * The selected locoation - bound to the location select
        * @type {String}
        */
        location: '',

        /**
        * Will be generated from the passed in members
        * @type {Array}
        */
        categories: [],

        /**
        * Will be generated from the passed in members
        * @type {Array}
        */
        types: [],

        /**
        * The selected category - bound to the category select
        * @type {String}
        */
        type: '',

        /**
        * The selected category - bound to the category select
        * @type {String}
        */
        category: '',

        /**
        * This will contain our filtered members
        * @type {Array}
        */
        filteredList: [],

        isReady: false
      };
    },

    computed:{
    },

    watch: {
      // we want to watch the category and keywords variables
      // and call `filterAll()` on either of them changing
      // this will ensure both filters are applied
      category () {
        this.filterAll();

        this.locations = this.getLocationsFromExperiences(this.filteredList);

        this.$nextTick(() => {
          this.callFoundation();
        });
      },

      location () {
        this.filterAll();

        this.$nextTick(() => {
          this.callFoundation();
        });
      },

      type () {
        this.filterAll();

        this.categories = this.getCategoriesFromExperiences(this.filteredList);

        this.$nextTick(() => {
          this.callFoundation();
        });
      },

      keywords () {
        this.filterAll();

        this.categories = this.getCategoriesFromExperiences(this.filteredList);
        this.locations = this.getLocationsFromExperiences(this.filteredList);

        this.$nextTick(() => {
          this.callFoundation();
        });
      }
    },

    mounted () {

      this.categories = this.getCategoriesFromExperiences();
      this.locations = this.getLocationsFromExperiences();
      this.types = this.getTypesFromExperiences();

      // this.createMap();

      // Reset app on mounted
      this.resetAllFilters();

      if (window.location.search) {

        //IE FIXES
        var queryString = window.location.search;
        let mapPreFilter = this.parseQueryString(queryString);
        // parseQueryString(queryString);
        if (typeof(mapPreFilter.type) !== "undefined") {
          this.type = mapPreFilter.type;
          console.log('In type');
        }

        if (typeof(mapPreFilter.category) !== "undefined") {
          this.category = mapPreFilter.category;
          console.log('In category');
        }

        if (typeof(mapPreFilter.search) !== "undefined") {
          this.keywords = mapPreFilter.search;
          console.log('In search');
        }

        if (typeof(mapPreFilter.near) !== "undefined") {
          this.location = mapPreFilter.near;
          console.log('In near');
        }

        console.log(this.keywords);
        console.log(this.type);
        console.log(this.location);
        console.log(this.category);
      }
    },

    methods: {
      // Renit foundation components
      callFoundation () {
        this.$nextTick(() => {
          $(this.$el).foundation();
          // Foundation.reInit('data-accordion')
        })
      },

      /**
      * Convert a title to url title
      * @param {title}
      * @return {url_title}
      */
      titleToUrlTitle (title) {
        return title
        .toLowerCase()
        .replace(/[^\w ]+/g,'')
        .replace(/ +/g,'-');
      },

      // Parse url with query string
      parseQueryString(queryString) {
        var params = {}, queries, temp, i, l;
        // Split into key/value pairs
        queries = queryString.replace('?','');
        queries = queries.split("&");
        // Convert the array of strings into an object
        for ( i = 0, l = queries.length; i < l; i++ ) {
          temp = queries[i].split('=');
          params[temp[0]] = temp[1];
          // console.log(temp);
        }
        return params;
      },

      /**
      * Filter everything
      * @return {void}
      */
      filterAll () {
        this.isReady = false;

        // reset the list to all members first
        this.filteredList = this.members;
        this.filterByKeywords();
        this.filterByCategory();
        this.filterByLocation();
        this.filterByType();

        this.isReady = true;
      },

      /**
      * Reset the list back to it's initial state
      * This will trigger the filters and show everything
      * @return {void}
      */
      resetAllFilters () {
        this.callFoundation();

        this.filteredList = this.members;
        this.keywords = ''; // initial state is to show all categories
        this.category = 'all'; // initial state is to show all categories
        this.location = 'all'; // initial state is to show all locations
        this.type = 'all'; // initial state is to show all locations
      },

      getCategoriesFromExperiences ($items = this.members) {

        let appScope = this;

        let categories = $items.map(member => {
          if (appScope.type != 'all') {
            return member.categories.filter(category => {
              return category['category_parent_slug'] === appScope.type;
            });
          } else {
            return member.categories;
          }
        });

        // horrible name, horrible, but we need to flatten those categories
        // Haha flat kitties, only kidding, we love cats here.
        let flatCats = [].concat.apply([], categories);

        // Generate unique objects
        flatCats = flatCats.filter((obj, pos, arr) => {
          return flatCats.map(mapObj => mapObj['name']).indexOf(obj['name']) === pos;
        });

        return flatCats.sort(function( a, b ){
          return a.name > b.name ? 1 : -1;
        });
      },

      /**
      * Go through all supplied members and get the locations
      * @return {array}
      */
      getLocationsFromExperiences ($items = this.members) {

        let locations = $items.map(member => {
          return member.locations;
        });

        // horrible name, horrible, but we need to flatten those categories
        let flatCats = [].concat.apply([], locations);


        // Generate unique objects
        flatCats = flatCats.filter((obj, pos, arr) => {
          return flatCats.map(mapObj => mapObj['name']).indexOf(obj['name']) === pos;
        });

        return flatCats.sort(function( a, b ){
          return a.name > b.name ? 1 : -1;
        });
      },

      /**
      * Go through all supplied members and get the locations
      * @return {array}
      */
      getTypesFromExperiences () {

        let types = this.members.map(member => {
          return member.types;
        });

        // horrible name, horrible, but we need to flatten those categories
        let flatCats = [].concat.apply([], types);


        // Generate unique objects
        flatCats = flatCats.filter((obj, pos, arr) => {
          return flatCats.map(mapObj => mapObj['name']).indexOf(obj['name']) === pos;
        });

        return flatCats.sort(function( a, b ){
          return a.name > b.name ? 1 : -1;
        });
      },

      /**
      * Filter the list from the free text search
      * Nothing too fancy, but it works
      * @return {void}
      */
      filterByKeywords () {
        if (!this.keywords) {
          return;
        }

        this.filteredList = this.filteredList.filter(member => {
          // bringing everything to lowercase to make comparisons more reliable
          // i.e., "Search" !== "search"
          let memberName = member.title.toLowerCase();
          let searchQuery = this.keywords.toLowerCase();

          if (searchQuery !== '') {
            this.resetVisible = true;
          }

          return memberName.indexOf(searchQuery) !== -1;
        });
      },

      /**
      * Filter the list by category
      * @return {void}
      */
      filterByCategory () {
        if (!this.category) {
          return;
        }

        if (this.category !== 'all') {
          this.filteredList = this.filteredList.filter(member => {
            this.resetVisible = true;

            let thisMember = member;

            let targetCategory = this.category;

            return thisMember.categories.map(cat => cat.slug).indexOf(targetCategory) !== -1;
          });
        }
      },

      /**
      * Filter the list by location
      * @return {void}
      */
      filterByLocation () {
        if (!this.location) {
          return;
        }

        if (this.location !== 'all') {
          this.filteredList = this.filteredList.filter(member => {
            this.resetVisible = true;

            let thisMember = member;

            let targetLocation = this.location;

            return thisMember.locations.map(loc => loc.slug).indexOf(targetLocation) !== -1;
          });
        }
      },
      /**
      * Filter the list by location
      * @return {void}
      */
      filterByType () {
        if (!this.type) {
          return;
        }

        if (this.type !== 'all') {
          this.filteredList = this.filteredList.filter(member => {
            this.resetVisible = true;

            let thisMember = member;

            let targetType = this.type;

            return thisMember.types.map(loc => loc.slug).indexOf(targetType) !== -1;
          });
        }
      }

    }
  };
</script>



// WEBPACK FOOTER //
// src/js/vue/member-map.vue